import { render, staticRenderFns } from "./materiais-icon.vue?vue&type=template&id=23288480&"
import script from "./materiais-icon.vue?vue&type=script&lang=js&"
export * from "./materiais-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports